import React, { Component } from "react";
import { Link } from 'react-router-dom';
const Portfolio_image = <img src="/assets/images/portfolio/evvaicom.png" alt="Evvai.com" />;
const Portfolio_imageear = <img src="/assets/images/portfolio/theear.png" alt="The Ear platform.com" />;
const Portfolio_image2 = <img src="/assets/images/portfolio/blacoit.png" alt="Blaco.it" />;
const Portfolio_image3 = <img src="/assets/images/portfolio/tocfood.png" alt="Tocfood.com" />;
 
const PortfolioListContent = [
     {
        image: Portfolio_imageear,
        category: 'Sito web / Giochi / Piattaforma / Api',
        code:'Lumen - Node - Vue - React - MongoDB - Mysql',
        title: 'The Ear Platform / Casino',
        description: 'Software house specializzata nello sviluppo di soluzioni per il settore iGaming.'
    },
    {
        image: Portfolio_image,
        category: 'Sito web / Gestionale / Api',
        code:'Laravel - MongoDB - Python - Codeigniter - MariaDB - Doctrine',
        title: 'Evvai.com',
        description: 'Tour operator online specialista delle vacanze al mare.'
    },
    {
        image: Portfolio_image2,
        category: 'Gestionale / Api',
        title: 'Blaco.it',
        code:'Laravel - MongoDB - SqlServer - Shopware',
        description: 'Vendita di prodotti per parrucchieri, estetiste e altro.'
    },
    {
        image: Portfolio_image3,
        category: 'Gestionale',
        title: 'Tocfood.it',
        code:'Laravel - MongoDB',
        description: 'App delivery pizzerie e ristoranti per consegne a domicilio.'
    },
    {
        image: <img src="/assets/images/portfolio/lasim.png" alt="Lasim.it" />,
        category: 'Gestionale',
        title: 'lasim.it',
        code:'Laravel - MongoDB - SqlServer',
        description: 'Stampaggio lamiera e lastratura mercato automotive.'
    },
    {
        image: <img src="/assets/images/portfolio/spazioalbum.png" alt="spazioalbum.it" />,
        category: 'Sito web',
        title: 'spazioalbum.it',
        code:'Visual Basic',
        description: 'E-commerce per acquisto e vendita di album fotografici.'
    },
    {
        image: <img src="/assets/images/portfolio/magazineevvai.png" alt="Magazine Evvai.com" />,
        category: 'Sito web',
        code:'Wordpress',
        title: 'magazine.evvai.com',
        description: 'Il Magazine dei viaggi e delle vacanze di Evvai.com.'
    },
    {
        image: <img src="/assets/images/portfolio/salentonet.png" alt="SalentoNet" />,
        category: 'Sito web',
        title: 'salentonet.it',
        code:'Codeigniter - mysql',
        description: 'Portale Turistico per le tue vacanze in Puglia.'
    },
    {
        image: <img src="/assets/images/portfolio/traipler.png" alt="Traipler.com" />,
        category: 'Sito web',
        title: 'traipler.com',
        code:'Laravel',
        description: 'Produzioni Video & Video Marketing.'
    },
    {
        image: <img src="/assets/images/portfolio/gamemath.png" alt="Game Math" />,
        category: 'Applicativo web',
        title: 'Giochi matematici',
        code:'React',
        description: 'Creazione di giochi matematici per bambini .'
    },
    {
        image: <img src="/assets/images/portfolio/tecnoenergine.png" alt="tecnoenergine.it" />,
        category: 'Sito web',
        title: 'tecnoenergine.it',
        code:'Wordpress',
        description: 'Motori: rigenerazione, rettifica e ricambi.'
    },
    {
        image: <img src="/assets/images/portfolio/infocamere.png" alt="Infocamere" />,
        category: 'Gestionale',
        title: 'infocamere',
        code:'Laravel - mysql',
        description: 'Visure e certificati online.'
    },
    {
        image: <img src="/assets/images/portfolio/servito.png" alt="Servito" />,
        category: 'Gestionale',
        title: 'servito.app',
        code:'Laravel - mysql',
        description: ' Servizi per risparmiare tempo nella cura dell\'auto.'
    },
    {
        image: <img src="/assets/images/portfolio/legalink.png" alt="Legalink" />,
        category: 'Sito web',
        title: 'legalink.it',
        code:'React - laravel - mysql',
        description: 'Community di avvocati nell’ottica del competence sharing.'
    },
  
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`im_portfolio ${styevariation}`}>
                            <div className="thumbnail_inner">
                                <div className="thumbnail">
                                    {value.image}                                       
                                </div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <div className="portfolio_heading">
                                        <div className="category_list">
                                            <span class="cat"> {value.category}</span>
                                            <span > {value.code}</span>
                                        </div>
                                        <h4 className="title">
                                            <span  >{value.title}</span>
                                        </h4>
                                    </div>
                                    <div className="portfolio_hover">
                                        <p>{value.description}</p>
                                    </div>
                                </div>
                            </div>
                            <span className="transparent_link"  ></span>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;